import { Row, Rows } from "../../../interfaces";
import { withCellStyles, getCell, formats } from "../../../utils";
import { generateExcelSumFormulaForGrandOrSubTotal, headerToColumnLetter } from "../../../utils/functions";
import { BmTemplateInternals, BudgetModalTemplateCurrentState } from "../budget-helper-internal";
import { boldAndBackgroundGray, textBold } from "../../../excelStyles";

export class TotalCapitalRequiredSection {
  constructor(
    private readonly helper: BmTemplateInternals,
  ) { }

  fillTotalCapitalRequiredRows(rows: Rows, current: BudgetModalTemplateCurrentState): void {
    this.prepareTotalCapitalReq(rows, current);
    this.prepareTotalCapitalReqPcnt(rows, current);
  }

  private prepareTotalCapitalReq(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const totalCapitalReqRow: Row = [];
    totalCapitalReqRow.push(withCellStyles('Total capital required', textBold));

    current.expandedHeadersWithYear.forEach((header) => {
      // null header marks an empty narrow column,
      // header can not be undefined
      if (header === null) {
        totalCapitalReqRow.push(null);
      } else if (header !== 'Budget') {
        totalCapitalReqRow.push(withCellStyles(getCell({
          f: generateExcelSumFormulaForGrandOrSubTotal(header, current.expandedHeadersWithYear, current.totalCapitalReqIndex),
          z: formats.thousandsSeparator, t: 'n',
        }), header.includes('Y') ? boldAndBackgroundGray : textBold));
      }
    });

    this.helper.pushYearsTotalCellBold(totalCapitalReqRow, current.rowIndex, current.yearsIndexArray);
    this.helper.prepareCellForTotalPcnt(totalCapitalReqRow, current, true);
    this.helper.setCellForTotalPcntOfCommitment(totalCapitalReqRow, current.rowIndex, current.indexOfTotalColumn, true);
    newData.push(totalCapitalReqRow);
  }

  private prepareTotalCapitalReqPcnt(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const totalCapitalReqPcntRow: Row = [];
    totalCapitalReqPcntRow.push(withCellStyles('Total capital required %', textBold));

    current.expandedHeadersWithYear.forEach((header) => {
      // null header marks an empty narrow column,
      // header can not be undefined
      if (header === null) {
        totalCapitalReqPcntRow.push(null);
      } else if (header !== 'Budget') {
        totalCapitalReqPcntRow.push(withCellStyles(getCell({
          f: `IFERROR(${headerToColumnLetter(header, current.expandedHeadersWithYear)}${current.rowIndex}/${current.totalCommitment},0)`,
          z: formats.percents, t: 'n',
        }), header.includes('Y') ? boldAndBackgroundGray : textBold));
      }
    });

    this.helper.setEmptyTotalsRowWithStyle(totalCapitalReqPcntRow);
    newData.push(totalCapitalReqPcntRow);
    current.rowIndex++;
    current.rowIndex++;
  }
}
